<script setup lang="ts">
import { WalletConnectStatus } from '@shared/types'
import { Status, StatusType } from '@injectivelabs/utils'
import * as WalletTracker from '@/app/providers/mixpanel/WalletTracker'
import { InitialStatusKey } from '@/types'

const route = useRoute()
const router = useRouter()
const walletStore = useWalletStore()
const sharedGeoStore = useSharedGeoStore()
const sharedSpotStore = useSharedSpotStore()
const sharedTokenStore = useSharedTokenStore()
const sharedWalletStore = useSharedWalletStore()
const sharedDerivativeStore = useSharedDerivativeStore()
const { $onError } = useNuxtApp()

const status = reactive(new Status(StatusType.Loading))
const unknownTokenStatus = reactive(new Status(StatusType.Loading))

onMounted(async () => {
  if (route.query.automation === 'true') {
    ;(window as any).ethereum = new CustomEip1193Provider()
  }

  handleGoogleOAuth()
  sharedTokenStore.fetchSupply().finally(() => unknownTokenStatus.setIdle())

  Promise.all([
    walletStore.init(),
    sharedSpotStore.fetchAllMarkets(),
    sharedGeoStore.fetchGeoLocation(),
    sharedDerivativeStore.fetchAllMarkets(),
    sharedTokenStore.fetchTokensUsdPriceMap()
  ])
    .catch($onError)
    .then(() => {
      if (sharedWalletStore.isUserConnected) {
        WalletTracker.trackWalletAddress(sharedWalletStore.injectiveAddress)
      }
    })
    .finally(() => {
      status.setIdle()
    })
})

onWalletInitialConnected(() => {
  WalletTracker.trackLogin({
    wallet: sharedWalletStore.wallet,
    address: sharedWalletStore.injectiveAddress
  })
})

onBroadcastResponse((response) => {
  const notificationStore = useSharedNotificationStore()

  notificationStore.$patch({ txResponse: response })
  notificationStore.initTelemetry()
})

function handleGoogleOAuth() {
  if (sharedWalletStore.isUserConnected) {
    return
  }

  if (!route.hash) {
    return
  }

  const params = new URLSearchParams(route.hash.substring(1))
  const idToken = params.get('id_token')

  if (!idToken) {
    return
  }

  router.replace({ hash: '' })

  sharedWalletStore
    .initTurnkeyGoogle(idToken)
    .catch($onError)
    .finally(() => {
      sharedWalletStore.walletConnectStatus = WalletConnectStatus.idle
    })
}

provide(InitialStatusKey, status)

useIntervalFn(() => sharedTokenStore.fetchTokensUsdPriceMap(), 30 * 1000)
</script>

<template>
  <UApp>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </UApp>
</template>
